import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Spin, message, Card } from 'antd';
import { gql, useMutation, useQuery } from '@apollo/client';

import Layout from '../Layout/index';
import ErrorBoundary from '../../components/Utils/ErrorBoundary';

import { PermissionGrid } from '../../components/Settings';

import { ROLE_PERMISSIONS_QUERY } from '../../apollo/queries';

const PERMISSIONS_UPDATE_QUERY = gql`
  mutation UpdatePermissions($input: [UpdatePermissionInput!]!) {
    updatePermissions(input: $input)
  }
`;

const RolePermissions = (props) => {
  const {
    loading: loadRolePermissions,
    data,
    refetch,
  } = useQuery(ROLE_PERMISSIONS_QUERY, { fetchPolicy: 'network-only' });

  const [updatePermissions, { loading: doingUpdate }] = useMutation(
    PERMISSIONS_UPDATE_QUERY
  );

  const onSuccessMutation = (mesageText = 'Details updated sccessfully!') => {
    refetch();
    message.success(mesageText);
  };

  const onSavePermissions = ({ permissions }) => {
    console.log('onSavePermissions called with ///', permissions);
    updatePermissions({
      variables: {
        input: permissions.map((perm) => {
          const [role_id, perm_id] = perm.split('_');
          return { role_id: parseInt(role_id), perm_id: parseInt(perm_id) };
        }),
      },
    })
      .then(({ data: { updatePermissions } }) => {
        console.log('onSavePermissions done', updatePermissions);
        if (updatePermissions) {
          onSuccessMutation('Permission update!');
        }
      })
      .catch((e) => {
        console.log('mutationError ////', e, e.graphQLErrors);
        let error = 'Some error occured, Please try again !!!';
        message.error(error);
      });
  };

  return (
    <Layout title="Permission Settings">
      <ErrorBoundary>
        <Spin spinning={loadRolePermissions || doingUpdate}>
          <Card style={{ minHeight: '200px', borderTop: '0' }}>
            {data && data.getRolePermissions && (
              <PermissionGrid
                rolePermissions={data.getRolePermissions}
                onSavePermissions={onSavePermissions}
              />
            )}
          </Card>
        </Spin>
      </ErrorBoundary>
    </Layout>
  );
};

export default RolePermissions;
